import React, { memo } from 'react';
import PropTypes from 'prop-types';

const DistributorsTableMobile = ({ distributors }) => {
  return (
    <div className="cases-table-mobile">
      {distributors.map((distributor) => {
        return (
          <div key={distributor.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{distributor.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {distributor.name}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

DistributorsTableMobile.propTypes = {
  distributors: PropTypes.array,
};

export default memo(DistributorsTableMobile);
